import { App } 			from 'vue'
import { Options } 		from './types'
import { useAuthStore } from './store/auth.store'

export default {
	install: (app: App, options: Options) => {
		if (options && options.disabled === true)
			return

		const authStore = useAuthStore()
		app.config.globalProperties.$authStore = authStore
	}
}

export function setAuthGlobal(app: App) {
	const authStore = useAuthStore()
	app.config.globalProperties.$authStore = authStore
}